<template>
  <div class="invoice-record">
    <div class="record-card">
      <div class="my-card-title">我的开票</div>
      <div class="table-wrap">

        <div class="data-type-wrap">
          <div class="item" @click="changeTab(null)" :class="[listQuery.status == null ? 'active' : '']">全部</div>
          <div class="item" @click="changeTab(0)" :class="[listQuery.status == 0 ? 'active' : '']">开票中</div>
          <div class="item" @click="changeTab(1)" :class="[listQuery.status == 1 ? 'active' : '']">已开票</div>
          <div class="item" @click="changeTab(2)" :class="[listQuery.status == 2 ? 'active' : '']">已驳回</div>
        </div>

        <el-table :data="list" v-loading="loading" element-loading-text="给我一点时间" :empty-text="emptyText" border>
          <el-table-column label="编号" align="center" width="80" prop="id">
          </el-table-column>
          <el-table-column label="开票单号" align="center" width="160" prop="invoice_no">
          </el-table-column>
          <el-table-column label="发票抬头" align="center" minWidth="150" prop="name">
          </el-table-column>
          <el-table-column label="开票金额" align="center" width="150">
            <template slot-scope="{row}">
              <span>{{ formatPrice(row.price) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="100" prop="status_name">
          </el-table-column>
          <el-table-column label="创建时间" align="center" width="100" prop="create_time">
          </el-table-column>
          <el-table-column label="操作" align="center" width="100" fixed="right">
            <template slot-scope="{row}">
              <el-link type="text" class="colorBlue" @click="handleDetail(row)" :underline="false">详情</el-link>
            </template>
          </el-table-column>
        </el-table>

        <div class="flex-row mgt20">
          <div class="flex-grow-1"></div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInvoiceList } from "@/api/invoice";
export default {
  name: 'InvoiceList',
  components: {

  },
  data() {
    return {
      loading: true,
      emptyText: '暂无数据',
      listQuery: {
        status: null,
        page: 1,
        pagesize: 10
      },
      list: [],
      total: 0,
    };
  },
  computed: {

  },
  created() {
    this.formatPrice = this.utils.formatPrice
    this.getList();
  },
  methods: {
    changeTab(e) {
      this.listQuery.status = e
      this.list = [];
      this.total = 0;
      this.handleFilter()
    },
    // 获取列表
    getList() {
      this.loading = true;
      const _listQuery = Object.assign({}, this.listQuery);
      getInvoiceList(_listQuery)
        .then((response) => {
          this.list = response.data.list;
          this.total = response.data.count * 1;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleDetail(row) {
      this.$router.push({ path: '/invoice/detail', query: { id: row.id } })
    },
    // 查询
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 更改每页行数
    handleSizeChange(val) {
      this.listQuery.pagesize = val;
      this.getList();
    },
    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  }
};
</script>

<style lang="scss" scoped>
.invoice-record {
  width: 100%;
  padding: 25px 0 227px 0;

  .data-type-wrap {
    display: flex;
    align-items: center;
    column-gap: 20px;
    margin-bottom: 27px;

    .active {
      color: #FFFFFF !important;
      background: #00B4E8 !important;
    }

    .item {
      font-size: 16px;
      font-weight: 400;
      color: #00B4E8;
      background: #00b6e81a;
      padding: 7px 30px;
      cursor: pointer;
    }
  }

  .record-card {
    background: #FFFFFF;

    .table-wrap {
      padding: 20px 32px;

    }
  }
}
</style>
